const ellipsis = "…";
export var Context2d;
(function (Context2d) {
    Context2d.truncateText = (context, text, maxWidth) => {
        if (text.length === 0) {
            return { text: "", width: 0 };
        }
        let width = context.measureText(text).width;
        if (width <= maxWidth) {
            return { text, width };
        }
        const ellipseWidth = context.measureText(ellipsis).width;
        let l = 0 | 0;
        let r = text.length | 0;
        while (l < r) {
            const mid = (r + l) >>> 1;
            width = context.measureText(text.substring(0, mid + 1)).width + ellipseWidth;
            if (width <= maxWidth) {
                l = mid + 1;
            }
            else {
                r = mid;
            }
        }
        if (l === 0) {
            return { text: "", width: 0 };
        }
        const result = text.substring(0, l);
        return { text: result + ellipsis, width: context.measureText(result).width + ellipseWidth };
    };
})(Context2d || (Context2d = {}));
